<!-- 线上基础类别 -->
<template>
  <div class="class-fa">
    <div>
      <div class="l-title">
        线上基本类别
      </div>
      <dyhOnlineclass ref="dyhOnlineclassRef" :btnshow="true" @systemReturn="systemReturn" @remove="remove">
      </dyhOnlineclass>
    </div>
    <div class="r-body">
      <div class="card-right">
        <el-form ref="form" :model="class_data" label-width="150px">
          <el-form-item label="上级类别：">
            <el-input placeholder="" v-model="class_data.parent_no">
              <template slot="prepend">{{ parent_name }}</template>
            </el-input>
          </el-form-item>
          <el-form-item label="类别：">
            <el-input placeholder="" v-model="class_data.classify_no" maxlength="2" show-word-limit>
              <template slot="prepend">{{ my_self }}</template>
            </el-input>
          </el-form-item>

          <el-form-item label="类别名称：">
            <el-input v-model="class_data.classify_name"></el-input>
          </el-form-item>
          <el-form-item label="描述：">
            <el-input v-model="class_data.describe"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="onSubmit('CG')">新建类别</el-button>
            <el-button type="primary" @click="onSubmit('CA')">修改类别</el-button>
            <br />
            <div style="color:#606266;">
              <!-- 新建类别不需要填写本级目录，修改类别需要填写本级目录。 -->
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
// import systemcs from "@/components/systemcs.vue";
import dyhOnlineclass from "@/components/dyh-onlineclass.vue";
import { classifyList } from "@/api/merchant.js";
import {
  classifyModify,
  classifyGenerate,
  classifyDelete
} from "@/api/service.js";
export default {
  name: "onlinebaseclassinfo",
  watch: {
    innerWH: {
      handler(newinner, oldinner) {
        if (newinner.innerHeight < 700) {
          this.scroll_height = newinner.innerHeight - 160;
        } else {
          this.scroll_height = newinner.innerHeight - 190;
        }
      },
      deep: true,
      immediate: true
    },
    "class_data.parent_no": {
      handler(np, op) {
        this.spClassNo(np);
        this.my_self = np;
      }
    }
  },
  computed: {
    innerWH() {
      return this.$store.state.resolution.innerWH;
    }
  },
  data() {
    return {
      allClassList: [],
      scroll_height: "",
      class_data: {
        classify_name: "",
        parent_no: "",
        describe: "",
        classify_no: ""
      },
      parent_name: "",
      my_self: ""
    };
  },
  components: { dyhOnlineclass },
  async mounted() {
    this.getClassifyList();
  },
  methods: {
    async getClassifyList() {
      this.allClassList = [];
      const res = await classifyList();
      this.allClassList = res;
    },
    remove(res) {
      const that = this;

      this.$confirm(
        `确定删除该类别吗?此操作会同时清空该类别的所有子类别。`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(async () => {
          const result = await classifyDelete(res.class_no);
          if (that.testR(result)) {
            if (result.data.resp_data.state === "SUCCESS") {
              that.successMessage(result.data.resp_data.message);
              that.getClassifyList();
              that.$refs.dyhOnlineclassRef.getClassifyList();
            }
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
      /* this.$alert(
        `确定删除${that.class_data.classify_no} ${that.class_data.classify_name}吗?如果该类为父类会清空其所有子类。`,
        "删除类别",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(async () => {
        })
        .catch(() => {
        }); */
    },
    spClassNo(pcn) {
      if (pcn === "0") {
        this.parent_name = "根类别";
        return;
      }

      for (let i = 0; i < this.allClassList.length; i++) {
        if (this.allClassList[i].class_no === pcn) {
          // this.class_data.parent_no = this.allClassList[i].parent_class_no;
          this.parent_name = this.allClassList[i].class_name;
        }
      }
    },
    systemReturn(res) {
      this.parent_name = "";
      if (this.class_data.classify_no === res || this.my_self + this.class_data.classify_no === res) {
        this.class_data = {
          classify_name: "",
          parent_no: "",
          describe: "",
          classify_no: ""
        };
        return;
      }

      this.my_self = "";
      for (let i = 0; i < this.allClassList.length; i++) {
        if (this.allClassList[i].class_no === res) {
          this.class_data.parent_no = this.allClassList[i].parent_class_no;
          this.my_self = this.allClassList[i].parent_class_no;
          if (this.allClassList[i].class_no.length > 2) {
            this.class_data.classify_no = this.allClassList[i].class_no.slice(
              -2
            );
          } else {
            this.class_data.classify_no = this.allClassList[i].class_no;
          }
          this.class_data.classify_name = this.allClassList[i].class_name;
          this.class_data.describe = this.allClassList[i].describe;
        }
      }
      for (let i = 0; i < this.allClassList.length; i++) {
        if (this.allClassList[i].class_no === this.class_data.parent_no) {
          this.parent_name = this.allClassList[i].class_name;
        }
      }
      if (this.parent_name === "") {
        this.parent_name = "根类别";
      }
    },
    async onSubmit(key) {
      var data = {
        ...this.class_data
      };
      if (this.class_data.parent_no.trim() !== "0") {
        data.classify_no = this.my_self + data.classify_no;
      }
      switch (key) {
        case "CG":
          data.parent_classify_no = this.class_data.parent_no;
          //eslint-disable-next-line
          const res = await classifyGenerate(data);
          if (this.testR(res)) {
            if (res.data.resp_data.state === "SUCCESS") {
              this.successMessage(res.data.resp_data.message);
              this.getClassifyList();
              this.$refs.dyhOnlineclassRef.getClassifyList();
            }
          }
          break;
        case "CA":
          //eslint-disable-next-line
          const result = await classifyModify(data);
          if (this.testR(result)) {
            if (result.data.resp_data.state === "SUCCESS") {
              this.successMessage(result.data.resp_data.message);
              this.getClassifyList();
              this.$refs.dyhOnlineclassRef.getClassifyList();
            }
          }
          break;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.class-fa {
  width: 100%;
  height: 100%;
  display: flex;
  background-color: #fff;
  border-radius: 5px;
}

.l-title {
  height: 40px;
  font-size: 20px;
  line-height: 2;
  padding: 0 0 10px 20px;
}

.r-body {
  width: calc(100% - 500px);
}

.card-right {
  width: auto;
  max-width: 600px;
  height: auto;
  /* background: rgb(205, 230, 255); */
  padding: 20px;
  margin-left: 10%;
  margin-right: 20px;
}
</style>
